import { ICopyChecklistServicoAmbienteUseCase } from "../../../presentation/useCases/create/copy_checklist_servico_ambiente_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CopyChecklistServicoAmbienteUseCase
 */

export class CopyChecklistServicoAmbienteUseCase implements ICopyChecklistServicoAmbienteUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async execute(
    idChecklistServicoAmbiente: number,
    descricao?: string,
    ordem?: string,
  ): Promise<void> {
    await this.repository.copiaChecklistServicoAmbiente(
      idChecklistServicoAmbiente,
      descricao,
      ordem,
    );
  }

}
